<template>
  <div>
    <div class="pa-4">
      <div class="cursor-move d-flex align-center">
        <app-material-icon
          name="open_with"
          class="mr-2"
        />
        <span class="font-weight-semi-bold text-text-primary">#{{ order }}</span>
      </div>

      <div class="steps-group my-4">
        <draggable
          :list="steps"
          item-key="id"
          :group="{
            name: 'steps-group',
            pull: ['steps-group', 'available-steps'],
            put: ['steps-group', 'available-steps'],
          }"
          :empty-insert-threshold="12"
          :component-data="{
            class: 'group-draggable-area',
          }"
          @change="onMoveStep"
        >
          <template #item="{ element: step }">
            <SigningChecklistStepToOrder
              :title="step.title"
              :index="step.position || step.display"
              removable
              @delete="$emit('delete-step', step)"
            />
          </template>
        </draggable>

        <span v-if="steps.length === 0" class="empty-group-placeholder">
          {{ $t('project.signing-checklist.order-signature.SigningChecklistStepsGroup.dragHint') }}
        </span>
      </div>

      <div class="d-flex justify-end">
        <app-button
          type="ghost"
          size="small"
          :disabled="signatureGroupsEditionPending"
          @click="$emit('delete-group')"
        >
          <app-material-icon name="delete" />
          {{$t('project.signing-checklist.order-signature.SigningChecklistStepsGroup.deleteGroupBtnLabel')}}
        </app-button>
      </div>
      <app-button
        class="my-4"
        type="outlined"
        variant="neutral"
        full-width
        :disabled="signatureGroupsEditionPending"
        @click="$emit('add-group')"
      >
        {{$t('project.signing-checklist.order-signature.SigningChecklistStepsGroup.addGroupBtnLabel')}}
      </app-button>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'

import SigningChecklistStepToOrder from './SigningChecklistStepToOrder.vue'

export default defineComponent({
  name: 'SigningChecklistStepsGroup',
  emits: [
    'add-group',
    'delete-group',
    'delete-step',
    'move-step',
  ],
  components: {
    SigningChecklistStepToOrder,
    draggable,
  },
  props: {
    order: {
      type: Number,
      required: true,
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('signingChecklistOrder', ['signatureGroupsEditionPending']),
  },
  methods: {
    onMoveStep ($event: ObjectWith<{ added?: any }>) {
      const { added } = $event
      if (added) {
        this.$emit('move-step', added.element)
      }
    },
  },
})
</script>

<style scoped lang="scss">
.steps-group {
  position: relative;
  border: 2px dashed rgb(var(--v-theme-border-primary));
  border-radius: 5px;
  background-color: rgb(var(--v-theme-surface-secondary));
  padding: 24px 12px;
}

.group-draggable-area {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.empty-group-placeholder {
  color: rgb(var(--v-theme-text-secondary));
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .group-draggable-area:not(:empty) + & {
    display: none;
  }
}
</style>
